import React from 'react'
import {BsCalendar2Week, BsChatSquareDots, BsPeopleFill, BsPersonBoundingBox, BsPersonWorkspace} from 'react-icons/bs'
import {RiAB} from 'react-icons/ri'
import CourseClassAttendanceTab from './tabs/CourseClassAttendanceTab'
import CourseClassGradeTab from './tabs/CourseClassGradeTab'
import CourseClassNewsTab from './tabs/CourseClassNewsTab'
import CourseClassTeachersStudentsTab from './tabs/CourseClassTeachersStudentsTab'
import CourseClassTimetableTab from './tabs/CourseClassTimetableTab'
import CourseClassStudentTab from './tabs/CourseClassStudentTab'

// Tab "Tổng quan" (information, trước là tab home icon-only đứng đầu) đã BỎ khỏi thanh tab chính -
// component CourseClassInforTab.js + DateProgressBar vẫn giữ nguyên trong repo (không xoá), vì
// DateProgressBar đã được xác nhận sẽ tái dùng lại ở chỗ khác sau này.
export const courseClassRouteEntities = [
    {
        // "Lịch trình & Tiến độ" đứng ĐẦU (tab mặc định khi vào lớp) - gồm 2 sub-tab nội bộ "Lịch
        // học & Điểm danh" (nội dung cũ - lịch buổi học/điểm danh của CHÍNH mình, kèm Lịch tháng) và
        // "Điểm số & Kết quả" (self-service, CHỈ hiện với is_student=true - xem CourseClassTimetableTab.js).
        icon: <BsCalendar2Week size={16}/>,
        path: 'timetables',
        component: CourseClassTimetableTab,
        breadcrumbName: (t) => t('schedule tab short'),
        // KHÔNG collapsedLabel - 3 tab đầu (Lịch trình & Tiến độ/Trao đổi/Giảng viên & Môn học) luôn
        // hiện tên đầy đủ (bạn yêu cầu), chỉ 3 tab quản trị phía dưới (Học viên/Điểm danh/Điểm số)
        // mới thu gọn còn icon khi không active - xem collapsedLabel ở 3 tab đó + CourseClassNav.js.
    },
    {
        icon: <BsChatSquareDots size={15}/>,
        path: 'news',
        component: CourseClassNewsTab,
        breadcrumbName: (t) => t('class news'),
        isInvisible: (props) => !!props?.item?.warnings,
    },
    {
        // Gộp "Giảng viên" + "Học viên" làm 1 tab - 2 khối xếp nối tiếp nhau trong
        // CourseClassTeachersStudentsTab. Trước đây khối thứ 2 là "Môn học" (đã bỏ, dư thừa - môn của
        // từng giảng viên đã hiện ngay dưới tên giảng viên rồi), giờ thay bằng danh sách học viên
        // RÚT GỌN (chỉ tên/mã/tổ/giới tính, để chính học viên trong lớp xem bạn học - KHÁC tab "Học
        // viên" quản trị đầy đủ ở path 'students' bên dưới, tab đó vẫn ẩn với học viên thường).
        // path GIỮ NGUYÊN 'teachers-subjects' (không đổi URL đang dùng/đã chia sẻ), chỉ đổi tên hiển
        // thị + nội dung.
        icon: <BsPersonWorkspace size={15}/>,
        path: 'teachers-students',
        component: CourseClassTeachersStudentsTab,
        breadcrumbName: (t) => t('teachers and students tab'),
        isInvisible: (props) => !!props?.item?.warnings,
    },
    {
        // "Học viên"/"Điểm danh"/"Điểm số" đều là 3 tab QUẢN TRỊ - ẩn hẳn với học viên thường (theo
        // yêu cầu, trước đây "Học viên"/"Điểm số" không ẩn - chỉ "Điểm danh" có sẵn isInvisible này).
        // Học viên xem lịch/điểm danh CỦA CHÍNH mình ở tab "Lịch trình" (MyClassSessionsPanel).
        icon: <BsPeopleFill size={15}/>,
        path: 'students',
        component: CourseClassStudentTab,
        breadcrumbName: (t) => t('students'),
        isInvisible: (props) => !props?.item?.edit,
        collapsedLabel: true,
    },
    {
        // Tab quản trị điểm danh (tạo/sửa/xoá buổi, thống kê theo học viên) - CHỈ dành cho giảng
        // viên/điều phối lớp, ẩn hẳn với học viên thường (trước đây học viên vẫn vào được tab này
        // và có toggle "Quản trị/Học viên" để xem thử - nay bỏ toggle, học viên xem lịch+điểm danh
        // của mình ở tab "Lịch trình" thay thế).
        icon: <BsPersonBoundingBox size={15}/>,
        path: 'attendances',
        component: CourseClassAttendanceTab,
        breadcrumbName: (t) => t('attendances'),
        isInvisible: (props) => !(props?.item?.edit || props?.item?.available_actions?.can_checkin),
        collapsedLabel: true,
    },
    {
        icon: <RiAB size={15}/>,
        path: 'grades',
        component: CourseClassGradeTab,
        breadcrumbName: (t) => t('tests / grades'),
        isInvisible: (props) => !props?.item?.edit,
        collapsedLabel: true,
    },
]
